// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8":"Work","9":"Contact","62":"HoverMenu","273":"NoMatch","274":"Home","450":"About"}[chunkId] + "." + {"8":"373d6b66","9":"5ddc9c56","62":"d5b7d163","273":"136971a9","274":"fdeacf00","450":"6278e5d9"}[chunkId] + ".chunk.css";
};